import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import Dialog from 'src/components/design-system/Dialog';
import useBoolean from 'src/hooks/useBoolean';
import { IGlSummary } from 'src/services/useActionRequiredInvoicesApi';
import { fToMMDDYY } from 'src/utils/formatTime';
import { warningIcon } from 'src/utils/icons';
import MultiPeriodGLSummary from '../MultiPeriodGLSummary';
import SinglePeriodGLSummary from '../SinglePeriodGLSummary';

const GLSummaryInfoField: FC<GridCellProps> = (props) => {
  const { dataItem } = props;
  const glSummaries: IGlSummary[] = useMemo(
    () =>
      dataItem?.glSummaries.map((summary: any) => ({
        ...summary,
        accountingPeriod: `${fToMMDDYY(summary.budgetPeriodStartDate)}-${fToMMDDYY(
          summary.budgetPeriodEndDate
        )}`,
      })) || [],
    [dataItem?.glSummaries]
  );

  const { value: open, setTrue: handleOpen, setFalse: handleClose } = useBoolean();

  return (
    <GridCellBase {...props} disableToolTip className="overflow-auto">
      <div className="flex items-center justify-center">
        <div
          style={{
            textAlign: 'center',
          }}
          className={`w-[22px] h-[22.5px] pb-[2px] text-white rounded-full cursor-pointer ${
            dataItem.isMultiPeriod ? 'bg-info' : 'bg-primary'
          } flex items-center justify-center `}
          title={dataItem.isMultiPeriod ? 'Multiple Periods Assigned' : 'Single Period Assigned'}
          onClick={handleOpen}
        >
          {dataItem.isMultiPeriod ? 'M' : 'S'}
        </div>
        <Dialog
          onClose={handleClose}
          open={open}
          title={
            <div>
              {dataItem.isMultiPeriod ? (
                <p className="flex items-center gap-3">
                  <span>GL Summary Info - {dataItem.invoiceNumber}</span>
                  <span className="flex items-center gap-1 p-[2px] bg-white text-xs text-black font-normal rounded">
                    {warningIcon} Multiple Periods Assigned
                  </span>
                </p>
              ) : (
                `GL Summary Info - ${dataItem.invoiceNumber}`
              )}
            </div>
          }
          width={'80%'}
          id="modal"
        >
          <div className="bg-opacity-50 w-full rounded-md break-words p-2 text-wrap mt-1 mb-1">
            {dataItem.isMultiPeriod ? (
              <MultiPeriodGLSummary glSummaries={glSummaries} />
            ) : (
              <SinglePeriodGLSummary glSummaries={glSummaries} />
            )}
          </div>
        </Dialog>
      </div>
    </GridCellBase>
  );
};

export default GLSummaryInfoField;
